module.exports = __webpack_public_path__ + "img/邀新码复制.d5a3730c.svg";